import { render, staticRenderFns } from "./comnonniketrm.vue?vue&type=template&id=630d1c2e&"
import script from "./comnonniketrm.vue?vue&type=script&lang=js&"
export * from "./comnonniketrm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QHeader,QToolbar,QBtn,QTooltip,QToolbarTitle,QCard,QImg,QCardSection} from 'quasar'
component.options.components = Object.assign({QHeader,QToolbar,QBtn,QTooltip,QToolbarTitle,QCard,QImg,QCardSection}, component.options.components || {})
